import React from 'react';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { FontesFormComp } from 'pages/fontes/pages/FontesForm';
import { FontesListComp } from 'pages/fontes/pages/FontesList';

export function FontesList() {
    return (
        <ListagemProvider>
            <FontesListComp />
        </ListagemProvider>
    );
}

export function FontesForm() {
    return (
        <FormProvider>
            <FontesFormComp />
        </FormProvider>
    );
}
